// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"61bc1cdc","239":"cdd2b7f6","453":"4662cfad","455":"8033cb65"}[chunkId] + ".chunk.js";
};